var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * @description Returns properties from an object by given key/s
 *
 * @param {Record<string, unknown>} object - object to search through
 * @param {string} keysToFind - keys to find properties
 *
 * @returns {Record<string, any>} - selected properties in object
 */
export var getPropertiesFromObject = function (object, keysToFind) {
    var selectedProperties = {};
    Object.entries(object).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (keysToFind.includes(key)) {
            selectedProperties[key] = value;
        }
        return key;
    });
    return selectedProperties;
};
//# sourceMappingURL=getPropertiesFromObject.js.map